import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-text">Alium</span>
              <span className="logo-accent">Software</span>
            </div>
            <p className="footer-description">
              Expert consultancy services for finance, healthcare, and cloud solutions. 
              Transforming businesses through innovative technology.
            </p>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-links">
              <li><a href="#services">Finance Consultancy</a></li>
              <li><a href="#services">Medical Consultancy</a></li>
              <li><a href="#services">Azure Cloud Solutions</a></li>
              <li><a href="#services">Custom Applications</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Company</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><button className="footer-link-button">Terms of Service</button></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4 className="footer-title">Connect</h4>
            <div className="social-links">
              <a href="https://linkedin.com/company/alium-software" className="social-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            </div>
            <p className="footer-contact">
              Email: hello@aliumsoftware.com<br />
              Phone: +44 (0) 7960 478672
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2026 Alium Software. All rights reserved.</p>
          <p className="footer-note">
            <em>We will help you grow your business however you want.</em>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;